import type { PlanFeePlanSnapshot } from "./types";

/** Hide property / fixed-asset rows (fee calculator = investable plans with summaries). */
export function isExcludedCalculatorPlan(plan: PlanFeePlanSnapshot): boolean {
  const t = (plan.planType ?? "").toLowerCase();
  const label = plan.planLabel.toLowerCase();
  if (t.includes("property") || t.includes("fixed_asset") || t.includes("real_estate")) {
    return true;
  }
  if (label === "property" || label.startsWith("second property")) {
    return true;
  }
  return false;
}

export function filterCalculatorPlans(plans: PlanFeePlanSnapshot[]): PlanFeePlanSnapshot[] {
  return plans.filter((p) => !isExcludedCalculatorPlan(p));
}
